const desktopQuery = window.matchMedia('(min-width: 750px)');

class ProductPurchaseSplit {
  constructor(section) {
    this.section = section;
    this.grid = section.querySelector('[data-product-grid-content]');
    this.details = this.grid?.querySelector('.product-details');
    this.detailsGroup = this.details?.querySelector(':scope > .group-block');
    this.detailsContent = this.detailsGroup?.querySelector(':scope > .group-block-content');
    this.originalGridChildren = this.grid ? [...this.grid.children] : [];
    this.originalDetailChildren = this.detailsContent ? [...this.detailsContent.children] : [];
    this.additionalBlocks = this.grid
      ? [...section.children].filter((node) =>
          Boolean(node.compareDocumentPosition(this.grid) & Node.DOCUMENT_POSITION_PRECEDING)
        )
      : [];
    this.handleViewportChange = this.handleViewportChange.bind(this);

    if (!this.grid || !this.detailsContent) return;

    desktopQuery.addEventListener('change', this.handleViewportChange);
    this.handleViewportChange();
  }

  handleViewportChange() {
    if (desktopQuery.matches) {
      this.enable();
    } else {
      this.disable();
    }
  }

  enable() {
    if (this.grid.dataset.purchaseSplitActive === 'true') return;

    const footerBlocks = this.originalDetailChildren.filter(
      (node) => node.dataset?.productPurchaseBlock === 'footer'
    );

    this.main = document.createElement('div');
    this.main.className = 'product-information__main';

    this.panel = document.createElement('aside');
    this.panel.className = 'product-information__purchase-panel';
    this.panel.setAttribute('aria-label', 'Product purchase options');

    this.scroll = document.createElement('div');
    this.scroll.className = 'product-information__purchase-scroll';
    this.footer = document.createElement('div');
    this.footer.className = 'product-information__purchase-footer';

    for (const child of this.originalGridChildren) {
      const destination = child === this.details ? this.scroll : this.main;
      destination.append(child);
    }
    for (const block of this.additionalBlocks) this.scroll.append(block);
    for (const block of footerBlocks) this.footer.append(block);

    const advert = document.querySelector('[data-foo-advert-section]');
    // Move only the advert's own content. Shopify section wrappers must remain
    // top-level siblings or the Theme Editor reports the product section as broken HTML.
    this.advertSection = advert;
    if (this.advertSection) {
      this.advertPlaceholder = document.createComment('FOO product advert images');
      this.advertSection.before(this.advertPlaceholder);
      this.advertSection.classList.add('product-information__advert');
      this.main.append(this.advertSection);
    }

    this.panel.append(this.scroll, this.footer);
    this.grid.append(this.main, this.panel);
    this.grid.dataset.purchaseSplitActive = 'true';
  }

  disable() {
    if (this.grid?.dataset.purchaseSplitActive !== 'true') return;

    for (const child of this.originalDetailChildren) this.detailsContent.append(child);
    for (const child of this.originalGridChildren) this.grid.append(child);
    this.grid.after(...this.additionalBlocks);
    const currentAdvert = this.main?.querySelector('[data-foo-advert-section]');
    const currentAdvertSection = currentAdvert || this.advertSection;
    if (currentAdvertSection && this.advertPlaceholder?.isConnected) {
      currentAdvertSection.classList.remove('product-information__advert');
      this.advertPlaceholder.replaceWith(currentAdvertSection);
    }
    this.main?.remove();
    this.panel?.remove();
    delete this.grid.dataset.purchaseSplitActive;
  }
}

function initializeProductPurchaseSplits(root = document) {
  for (const section of root.querySelectorAll('.product-information--purchase-split')) {
    if (section.dataset.purchaseSplitInitialized === 'true') continue;
    section.dataset.purchaseSplitInitialized = 'true';
    new ProductPurchaseSplit(section);
  }
}

initializeProductPurchaseSplits();
document.addEventListener('shopify:section:load', (event) => initializeProductPurchaseSplits(event.target));
